import { render, staticRenderFns } from "./RecordIOSettings.vue?vue&type=template&id=1c16fa90&scoped=true"
import script from "./RecordIOSettings.vue?vue&type=script&lang=ts"
export * from "./RecordIOSettings.vue?vue&type=script&lang=ts"
import style0 from "./RecordIOSettings.vue?vue&type=style&index=0&id=1c16fa90&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c16fa90",
  null
  
)

export default component.exports